import React from 'react';

import { OKTA_CONNECTOR_FIELDS } from '../../common/fields';
import Button from '../Controls/Button/Button';
import TextInput from '../Controls/TextInput/TextInput';

import styles from './AzureConnector.module.css';
import { httpGet, httpPost } from '../../../utils';
import { SettingsFeatureLock } from '../LockedFeatures/SettingsFeatureLock';
import { SUBCATEGORIES } from '../../common/categories';

const OktaConnector = ({ oktaConnector, changedFunc, disabled = false }) => {
    const oktaDomain = oktaConnector[OKTA_CONNECTOR_FIELDS.OKTA_DOMAIN.ID];
    const clientId = oktaConnector[OKTA_CONNECTOR_FIELDS.CLIENT_ID.ID];
    const clientSecret = oktaConnector[OKTA_CONNECTOR_FIELDS.CLIENT_SECRET.ID];
    const accessToken = oktaConnector[OKTA_CONNECTOR_FIELDS.ACCESS_TOKEN.ID];
    const hasClientSecret = oktaConnector[OKTA_CONNECTOR_FIELDS.HAS_CLIENT_SECRET.ID];
    const authorized = oktaConnector[OKTA_CONNECTOR_FIELDS.AUTHORIZED.ID];

    const authorize = async () => {
        try {
            const { data: generateResponse } = await httpPost('/Settings/generateOktaAccessToken', {
                oktaDomain: oktaDomain.value,
                clientId: clientId.value,
                clientSecret: clientSecret.value
            });

            if (!generateResponse.url) {
                throw new Error('Failed to generate URL');
            }

            window.open(generateResponse.url);
            const { data: authResponse } = await httpGet('/Settings/getOktaAccessTokenResponse');
            if (!authResponse) {
                throw new Error('Failed to get Auth Response');
            }

            changedFunc(OKTA_CONNECTOR_FIELDS.ACCESS_TOKEN.ID, authResponse.accessToken);
            changedFunc(OKTA_CONNECTOR_FIELDS.REFRESH_TOKEN.ID, authResponse.refreshToken);
            changedFunc(OKTA_CONNECTOR_FIELDS.AUTHORIZED.ID, true);
        } catch (error) {
            console.error('Failed to authorize application', error);
        }
    };

    return (
        <>
            <div className={styles.oktaBridgeConnector}>
                <SettingsFeatureLock id={SUBCATEGORIES.OKTA_CONNECTORS.ID} isTabId={true}>
                    <TextInput field={oktaDomain} changed={changedFunc} disabled={disabled} />
                </SettingsFeatureLock>
                <SettingsFeatureLock id={SUBCATEGORIES.OKTA_CONNECTORS.ID} isTabId={true}>
                    <TextInput field={clientId} changed={changedFunc} disabled={disabled} />
                </SettingsFeatureLock>
                <SettingsFeatureLock id={SUBCATEGORIES.OKTA_CONNECTORS.ID} isTabId={true}>
                    <TextInput
                        field={clientSecret}
                        placeholder={hasClientSecret.value ? '******' : ''}
                        type="password"
                        changed={changedFunc}
                        disabled={disabled}
                    />
                </SettingsFeatureLock>
                <div className={styles.buttonContainer}>
                    <SettingsFeatureLock id={SUBCATEGORIES.OKTA_CONNECTORS.ID} isTabId={true}>
                        <Button disabled={disabled} onClick={authorize}>
                            {authorized.value ? 'Reauthorize' : 'Authorize'}
                        </Button>
                    </SettingsFeatureLock>
                </div>
            </div>
            {accessToken && accessToken.notification && (
                <div className={styles.oktaNotificationText}>{accessToken.notification}</div>
            )}
        </>
    );
};

export default React.memo(OktaConnector);
